export const API_BASE_URL =  "https://api.poldentech.ru/"
//export const API_BASE_URL =  "https://testapi.poldentech.ru/"
//export const API_BASE_URL = "http://localhost:4567/"


// WEBPACK FOOTER //
// ./src/const.js